<div class="content-body">

    <div class="expansionPanel">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header [collapsedHeight]="'64px'" [expandedHeight]="'64px'">
                <mat-panel-title>
                    <div class="title">{{ title }}</div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <hr class="dividir">

            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-8" style="padding-left: 0px;">
                        <div class="icon-left">
                            <button class="iconBtn" (click)="create()">
                                    <fa-icon icon="plus-circle"></fa-icon>
                            </button>

                            <button class="iconBtn" (click)="deleteTrash()">
                                <fa-icon icon="trash"></fa-icon>
                            </button>
                        </div>
                    </div>

                    <div class="col-md-4" style="padding-right: 0px;">
                        <div class="seacrh">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Buscar..."
                                [(ngModel)]="search"
                            >
                            <fa-icon icon="search"></fa-icon>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
                        <table class="table table-body">
                            <thead>
                                <tr>
                                    <td>
                                        <input type="checkbox" name="all" (click)="checkAll($event)">
                                    </td>
                                    <td *ngFor="let list of titleTable" class="table-title" (click)="order(list.order)">
                                        <fa-icon icon="sort"></fa-icon>
                                        {{ list.name }}
                                    </td>
                                    <td class="table-title">
                                        Acciones
                                    </td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let list of list | search:search:modulo | orderBy:orderBy:reverse | paginate: { itemsPerPage: numPage, currentPage: pages }">
                                    <td>
                                        <input type="checkbox" name="check-{{list.id}}" [(ngModel)]="list.check" (change)="checkAcept($event, list.id)">
                                    </td>
                                    <td>{{ list.titulo}}</td>
                                    <td>{{ list.tipo_tratamiento.nombre }}</td>
                                    <td>{{ list.requiere_analisis | type:'change_boolean' }}</td>
                                    <td>{{ list.fecha_incidencia | type:'date' }}</td>
                                    <td>
                                        <div style="display: flex">
                                            <button class="action-icon-btn" (click)="detail(list)">
                                                <fa-icon icon="eye"></fa-icon>
                                            </button>
                                            <button class="action-icon-btn" (click)="update(list)">
                                                <fa-icon icon="pencil"></fa-icon>
                                            </button>
                                            <button class="action-icon-btn" (click)="delete(list)">
                                                <fa-icon icon="minus"></fa-icon>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="row" style="border-top: solid 1px #dee2e6; margin-top: 20px;">
                    <div class="col-md-12" style="padding-left: 0px; padding-right: 0px; margin-top: 30px;">
                        <div class="marge-right">
                            <pagination-template #p="paginationApi" (pageChange)="pages=$event">
                                <nav class="text-left">
                                    <ul class="pagination">
                                        <li class="page-item" [class.disabled]="p.isFirstPage()" style="cursor: pointer">
                                            <a class="page-link" (click)="p.previous()"> <span class="fa fa-angle-left"></span> Anterior</a>
                                        </li>

                                        <li *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value" class="page-item" [ngClass]="{'active' : p.getCurrent() === page.value}">
                                            <a class="page-link" (click)="p.setCurrent(page.value)"  *ngIf="p.getCurrent() !== page.value"> {{ page.label }} </a>
                                            <a class="page-link" *ngIf="p.getCurrent() === page.value"> {{ page.label }} </a>
                                        </li>

                                        <li class="page-item" [class.disabled]="p.isLastPage()" style="cursor: pointer">
                                            <a class="page-link" (click)="p.next()">Siguiente <span class="fa fa-angle-right"></span></a>
                                        </li>
                                    </ul>
                                </nav>
                            </pagination-template>
                        </div>
                    </div>
                </div>
            </div>

        </mat-expansion-panel>
    </div>

</div>
